var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row pt-4 mx-3"},[_c('div',{staticClass:"col-12"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }